import { FeatureMouseInteraction } from '@openlayers/interaction/FeatureMouseInteraction';
import { declusterFeature, isCluster, setMapCursor } from '@openlayers/ol-utils';
import { MapOverlays } from '@openlayers/ol-overlays';
import Feature from 'ol/Feature';
import { mapStateFacade } from '@pages/map/map';
import { PageStateService } from '@shared/user-state/PageStateService';
import { DateUtils } from '@shared/utils/DateUtils';


export class PageStateDesktopMouseInteraction extends FeatureMouseInteraction {

    onClick = (feature: Feature, e, n): void => {
        // clicked cluster > print list of states inside
        if (isCluster(feature)) {
            const clusterFeatures: Feature[] = feature.get('features');

            const [lat, lon] = clusterFeatures[0].getGeometry().getExtent();

            const ul = $('<div class="images-cluster-list" style="width: 300px; max-height: 55vh; overflow-x: hidden">');

            clusterFeatures.map(f => f.get('data')).forEach((data: IPageState) => {
                const html = `
<div onclick="event.stopPropagation(); mapStateFacade.fetchStateAndRestore('${data.uuid}', true)">
    <div class="flex-column" style="padding-right: 30px; overflow: hidden">
        <strong>${(data.name?.length > 0 ? data.name : null) ?? data.description ?? DateUtils.formatDateTime(data.timestamp)}</strong>
    </div>
</div>
`;
                ul.append(html);
            });

            MapOverlays.showDialog(this.map, ul, lat, lon, feature);
        }
        else if (feature) {
            mapStateFacade.fetchStateAndRestore(feature.get('data')?.uuid, true);
        }
    };

    currentHoverFeature = null;
    fetchServiceAbort: AbortController = null;
    stateCache: Record<string, IPageState> = {};

    onMouseOver = (feature: Feature, e, n): void => {
        setMapCursor(this.map, 'pointer');
        if (!feature || isCluster(feature)) return;

        feature = declusterFeature(feature);
        const data: IPageState = feature.get('data');

        if (this.currentHoverFeature !== feature) {
            this.currentHoverFeature = feature;
            if (this.fetchServiceAbort) {
                this.fetchServiceAbort.abort();
            }

            if (!this.stateCache[data.uuid]) {
                setTimeout(() => {
                    const tooltipEl = document.querySelector('#map-page-state-tooltip');
                    tooltipEl.classList.add('overlay-loading');
                }, 1);

                this.fetchServiceAbort = new AbortController();
                PageStateService.fetchItem(data.uuid, true, false, this.fetchServiceAbort.signal).then(resp => {
                    this.stateCache[data.uuid] = resp;

                    const tooltipEl = document.querySelector('#map-page-state-tooltip');
                    if (tooltipEl) {
                        tooltipEl.classList.remove('overlay-loading')
                        tooltipEl.querySelector('img').src = this.stateCache[data.uuid].thumbnail;
                    }
                })
            }
        }

        const imgData = this.stateCache[data.uuid]?.thumbnail ?? '';
        MapOverlays.showTooltip(this.map, `<div class='text-center' id="map-page-state-tooltip"><img class="card" style='display: inline-block; min-height: 80px; height: auto' src="${imgData}" width='160px'/></div>
<div class="card padded-half" style='font-size: 12px;'><strong>${data.name?.length > 0 ? data.name : ''}</strong><div style="max-width: 400px" class="ellipsis">${data.description ?? ''}</div><div>${DateUtils.formatDateTime(data.timestamp)}</div></div>`, e, n);
    };
}
